import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './html-sitemap.scss.js';
import '../accordion/index.js';
import '../../molecules/accordion-item/index.js';

const onAccordionItemToggle = (content) => {
    const links = content.querySelector('slot').assignedNodes()[0].querySelectorAll('a');
    links.forEach(a => {
        if (a.tabIndex === -1) {
            a.removeAttribute('tabindex');
        }
        else {
            a.setAttribute('tabindex', '-1');
        }
    });
};
const renderLvl0Link = (title, url) => x `<a class="lvl0-link" href="${url}" slot="accordion-item">${title}</a>`;
const renderAccordionItem = (title, content) => x `<accordion-item slot="accordion-item" highlightActiveItem smallTitles title="${title}" .onToggle="${onAccordionItemToggle}"><div slot="accordion-content"><ul>${content}</ul></div></accordion-item>`;
class HtmlSitemap extends s {
    constructor() {
        super(...arguments);
        this.htmlSitemapItems = [];
    }
    firstUpdated() {
        const htmlSitemap = document.querySelector('.cvt-html-sitemap');
        if (!htmlSitemap)
            return;
        this.htmlSitemapItems = Array.from(document.querySelectorAll('.cvt-html-sitemap > ul > li'));
        this.requestUpdate();
    }
    render() {
        return x `<div class="html-sitemap"><cvt-accordion>${this.htmlSitemapItems.map(item => {
            const lvl2 = item.querySelector('li');
            const link = item.querySelector('a');
            return lvl2
                ? renderAccordionItem(link.textContent, item)
                : renderLvl0Link(link.textContent, link.href);
        })}</cvt-accordion></div>`;
    }
}
HtmlSitemap.styles = css_248z;
customElements.define('html-sitemap', HtmlSitemap);

export { HtmlSitemap };
